import { useEffect, useState } from "react";
import "./style.css";
import { DashboardApis } from "../../apis/DashboardApis";
import { useHistory, useParams } from "react-router-dom";


export default function LeadsForm() {
    // eslint-disable-next-line no-unused-vars
    const [action, setAction] = useState('add')
    const [formData, setFormData] = useState({
        name: '',
        designation: '',
        organization: '',
        country: '',
        mobile: '',
        email: '',
        // page: '',
    })
    const history = useHistory()
    const { id } = useParams()
    useEffect(() => {
        if (id) {
            DashboardApis.getById(id).then(response => {
                setFormData({ ...response.data })
            })
        }
    }, [id])



    const resetFormData = () => {
        setFormData({
            name: '',
            designation: '',
            organization: '',
            country: '',
            mobile: '',
            email: '',
            page: ''
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (action === 'add') {
            await DashboardApis.create({ ...formData })
        } else if (action === 'update') {
            await DashboardApis.update(id, { ...formData })
        }
        resetFormData()
        history.push('/dashboard')
    }

    return (
        <div className="dashboard-section">
            <div className="dashboard-section-title">{action.toUpperCase()} Lead</div>

            <form className="dashboard-form" onSubmit={handleSubmit}>
                <div className="form-row">
                    <div className="form-group">
                        <label className="form-label">Name</label>
                        <input type="text" className="form-input" placeholder="Full name"
                            value={formData.name}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">Designation</label>
                        <input
                            type="text"
                            className="form-input"
                            placeholder="Designation"
                            value={formData.designation}
                            onChange={(e) => setFormData({ ...formData, designation: e.target.value })}
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group">
                        <label className="form-label">Country</label>
                        <input
                            type="text"
                            className="form-input"
                            placeholder="Country"
                            value={formData.country}
                            onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                        />
                    </div>

                {/* <div className="form-group">
                    <label className="form-label">Page</label>
                    <select className="form-input" value={formData.page} onChange={(e) => setFormData({ ...formData, page: e.target.value })}>
                        <option value="" defaultChecked disabled>Select a Page</option>
                        <option value="global-ai-academy">Global AI Academy</option>
                        <option value="digital-backbone">Digital Backbone</option>
                        <option value="impact-labs">Impact Labs</option>
                        <option value="capital-flywheel">Capital Flywheel</option>
                        <option value="acceleration-engine">Acceleration Engine</option>
                        <option value="global-partnership">Global Partnership</option>
                        <option value="invest-in-telegana">Invest In Telegana</option>
                    </select>


                </div> */}
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label className="form-label">Organization</label>
                        <input
                            type="text"
                            className="form-input"
                            placeholder="Organization name"
                            value={formData.organization}
                            onChange={(e) => setFormData({ ...formData, organization: e.target.value })}
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">Mobile</label>
                        <input
                            type="tel"
                            className="form-input"
                            placeholder="+91 XXXXX XXXXX"
                            value={formData.mobile}
                            onChange={(e) => setFormData({ ...formData, mobile: e.target.value })}
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group full">
                        <label className="form-label">Email</label>
                        <input
                            type="email"
                            className="form-input"
                            placeholder="email@example.com"
                            value={formData.email}
                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        />
                    </div>
                </div>

                <div className="form-actions">
                    <button type="submit" className="form-submit">
                        Save
                    </button>
                    <button type="button" className="form-cancel">
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
}
